import {
	getInstitutionExportUsers,
	getInstitutionExportGroups,
	getInstitutionExportLogs,
	queueInstitutionExport,
	getInstitution,
} from '@/api/unilogin';

const state = {};

const getters = {};

const actions = {
	getInstitutionExportUsers(_, { params, institutionId }) {
		return getInstitutionExportUsers(institutionId, params);
	},
	getInstitutionExportGroups(_, { params, institutionId }) {
		return getInstitutionExportGroups(institutionId, params);
	},
	getInstitutionExportLogs(_, { institutionId }) {
		return getInstitutionExportLogs(institutionId);
	},
	queueInstitutionExport(_, { institutionId }) {
		return queueInstitutionExport(institutionId);
	},
	getInstitution(_, { institutionId }) {
		return getInstitution(institutionId);
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
